import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';

import { isEmpty } from 'lodash';

import clsx from 'clsx';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb';
import ConfigureNiagaraPage from './ConfigureNiagaraPage';
import ConfigureBacnetPage from './ConfigureBacnetPage';
import BobPage from '../../../../components/BobPage';
import BobLoadingMask from '../../../../components/BobLoadingMask';

import * as BasAgentActions from '../../../../actions/basAgentActions';
import * as IotHubActions from '../../../../actions/iotHubActions';

import * as classes from './ConfigureAgentPage.module.css';

const ConfigureAgentPage = ({
    activeNavCompany,
    fetchBasAgent,
    history,
    selectedAgent,
    setSelectedAgent,
    ...props
}) => {
    const [basType, setBasType] = useState('');

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        const init = async () => {
            if (isEmpty(selectedAgent)) {
                const agent = await fetchBasAgent(queryValues.agent);
                if (agent.driverConfiguration && agent.driverConfiguration[0].basType.toLowerCase() !== 'notconfigured') {
                    setBasType(agent.driverConfiguration[0].basType.toLowerCase());
                }
                setSelectedAgent(agent);
            } else {
                if (selectedAgent.id !== queryValues.agent) {
                    const agent = await fetchBasAgent(queryValues.agent);
                    if (agent.driverConfiguration && agent.driverConfiguration[0].basType.toLowerCase() !== 'notconfigured') {
                        setBasType(agent.driverConfiguration[0].basType.toLowerCase());
                    }
                    setSelectedAgent(agent);
                } else {
                    if (selectedAgent.driverConfiguration && selectedAgent.driverConfiguration[0].basType.toLowerCase() !== 'notconfigured') {
                        setBasType(selectedAgent.driverConfiguration[0].basType.toLowerCase());
                    }
                }
            }
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 500
            },
        },
    };

    const handleNavigation = () => {
        const path = '/v2/dashboard/iothub/manage';

        history.push({ pathname: path, search: history.location.search });
    };

    const handleChangeBasType = event => {
        setBasType(event.target.value);
    };

    return (
        <BobPage>
            <div className={classes.CompanyPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.TitlePanel}>
                    <span><i role="none" onClick={() => handleNavigation()} className={clsx('fas fa-angle-left fa-lg', classes.Arrow)} /></span>
                    <span className={classes.Label}>Configure BAS Network</span>
                </div>
                <div className={classes.InfoPanel}>
                    <div className={classes.InfoHeader}>
                        Network Configuration
                        <div>
                            <FormControl variant="outlined" size="small" className={classes.Select}>
                                <InputLabel
                                    style={{
                                        backgroundColor: 'white',
                                        paddingRight:    '5px',
                                        paddingLeft:     '10px'
                                    }}
                                >
                                    <span>BAS System Driver<span className={classes.Required}> *</span></span>
                                </InputLabel>
                                <Select
                                    value={basType}
                                    classes={{ root: classes.SelectFont }}
                                    MenuProps={MenuProps}
                                    disabled={!isEmpty(selectedAgent.driverConfiguration) && selectedAgent.driverConfiguration[0].basType.toLowerCase() !== 'notconfigured'}
                                    onChange={(event) => handleChangeBasType(event)}
                                    className={classes.select}
                                    inputProps={{
                                        style: { fontSize: 14 },
                                        name:  'basType',
                                        id:    'basType'
                                    }}
                                >
                                    <MenuItem
                                        key={0}
                                        value={'niagara'}
                                    >
                                        Niagara
                                    </MenuItem>
                                    <MenuItem
                                        key={1}
                                        value={'bacnetip'}
                                    >
                                        BacnetIP
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    {
                        basType === 'niagara' ?
                            <ConfigureNiagaraPage
                                activeNavCompany={activeNavCompany}
                                selectedAgent={selectedAgent}
                            />
                            :
                            basType === 'bacnetip' ?
                                <ConfigureBacnetPage
                                    activeNavCompany={activeNavCompany}
                                    selectedAgent={selectedAgent}
                                />
                                :
                                null
                    }
                    {
                        isEmpty(selectedAgent) ?
                            <BobLoadingMask />
                            :
                            null
                    }
                </div>
            </div>
        </BobPage>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
    bobLoading:       state.bob.bobLoading,
    basAgents:        Object.values(state.basAgent.basAgents),
    selectedAgent:    state.basAgent.selectedAgent
});

const mapDispatchToProps = {
    ...BasAgentActions,
    ...IotHubActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfigureAgentPage));
